import { call, put } from 'redux-saga/effects';
import { AUTH_FAILURE } from '../constants/action-types';

function* sagaFetch(apiMethod, ...args) {
  const { response, error } = yield call(apiMethod, ...args);

  if (
    error &&
    error.status &&
    error.status === 401 &&
    error.message === 'Unauthorized'
  ) {
    yield put({ type: AUTH_FAILURE });
    return { error };
  }

  if (!error) {
    return { response };
  }

  return { error };
}

export function* catchableSagaFetch(apiMethod, ...args) {
  const { response, error } = yield call(apiMethod, ...args);

  if (
    error &&
    error.status &&
    error.status === 401 &&
    error.message === 'Unauthorized'
  ) {
    yield put({ type: AUTH_FAILURE });
    throw error;
  }

  if (!error) {
    return response;
  }

  throw error;
}

export default sagaFetch;
